export default __webpack_public_path__ + "static/media/novena.ff5c09fa.jpg";